import { useTranslation } from "react-i18next";
import { detectMobile } from "../../utils/formatting";
import Button from "../../Button/Button";
import { isUndefinedNullOrEmpty } from "../../utils/translation/helper";
import { useDispatch, useSelector } from "react-redux";
import HeaderJourney from "../../storybook/Header/HeaderJourney";
import { loginStatus, loginTime, userGetRepairData } from "../../ducks/redux/actions/userChoices";
import { getCustomerId, saveCustomerDetails, savePreviousPage } from "../../ducks/redux/actions/getAddress";
import { CASE_SELECTED_ANSWERS, CLEAR_CASE_STATE } from "../../ducks/redux/actionTypes";
import * as api from "../../api";
import React from "react";
import {
    selectedTabValue, selectedTenancyGroup, userChosenAdditionalDescription,
    userChosenContactDetails, userChosenContactName, userChosenContactPhone, userChosenCovidQuestion,
    userChosenDuplicateQuestion, userChosenEligibilityErrorCode, userChosenHighLevelDescription,
    userChosenPropertyAddress, userChosenPropertyId, userChosenPropertyType, userChosenRelationDetails,
    userChosenRepairLocation, userChosenSOR, userChosenSTATUS, userChosenSupplementaryQuestions,
    userChosenUPRN, userChosenVandalismAdditionalInformation, userChosenVandalismQuestion,
    userChosenVulnerabilityAdditionalInformation, userChosenVulnerabilityQuestion, userProfileData,
    demobilizedContractorSites, isMyPbRepairsMaintainence, repairPriorityValue, skipResponsibilityCheckForEMA
} from "../../ducks/redux/actions/userChoices";
import "./index.css";
import { comingFromRepairJourneySuccess } from "../../ducks/redux/actions/FinancialReferral";

const CustomerApiErrorPage: React.FC<any> = (props) => {
    const { t } = useTranslation();
    const isMobile = detectMobile();
    const dispatch = useDispatch();
    const loggedInStatus = useSelector(
        (state: any) => state?.userChoicesReducer?.loginStatus
    );
    const previousPage = useSelector(
        (state: any) => state?.addresses?.previousPage
    )
    const customerID = useSelector((state: any) => state.addresses?.customerid);

    const refreshButtonHandler = async () => {
        if (isUndefinedNullOrEmpty(loggedInStatus)) {
            props.history.push("/startpage");
        }
        else {
            try {
                const customerResponse = await api.getCustomer(customerID);
                dispatch(saveCustomerDetails(customerResponse));
                props.history.push(previousPage);
            }
            catch (e) {
                console.error(e);
                props.history.push('/customerApiErrorPage');
                window.location.reload();
            }
        }
    };

    const RedirectToLogOut = () => {
        RedirectToCSSLoginPage();
        dispatch(selectedTabValue("logout"))
    }

    const RedirectToCSSLoginPage = () => {
        dispatch(loginTime(""));
        dispatch(loginStatus(false));
        dispatch(loginStatus(""));
        dispatch(getCustomerId(""));
        clearCaseStoreData();
        api.clearSession();
        localStorage.clear();
        dispatch(userProfileData(""));
        dispatch(userChosenPropertyId(""));
        dispatch(userChosenPropertyType(""));
        dispatch(userChosenPropertyAddress(""));
        dispatch(userChosenRepairLocation(""));
        dispatch(userChosenHighLevelDescription(""));
        dispatch(userChosenSupplementaryQuestions(""));
        dispatch(userChosenDuplicateQuestion(""));
        dispatch(userChosenAdditionalDescription(""));
        dispatch(userChosenVandalismQuestion("No"));
        dispatch(userChosenVandalismAdditionalInformation(""));
        dispatch(userChosenCovidQuestion(""));
        dispatch(userChosenVulnerabilityQuestion(""));
        dispatch(userChosenVulnerabilityAdditionalInformation(""));
        dispatch(userChosenContactDetails(""));
        dispatch(userChosenUPRN(""));
        dispatch(userChosenSOR(""));
        dispatch(userChosenSTATUS(""));
        dispatch(userChosenEligibilityErrorCode(""));
        dispatch(userChosenContactPhone(""));
        dispatch(userChosenContactName(""));
        dispatch(userChosenRelationDetails(""));
        dispatch(selectedTenancyGroup(''))
        dispatch(demobilizedContractorSites([]));
        dispatch(isMyPbRepairsMaintainence(""))
        dispatch(repairPriorityValue(""))
        dispatch(userGetRepairData(""));
        dispatch(comingFromRepairJourneySuccess(false));
        dispatch(savePreviousPage(''));
        dispatch(saveCustomerDetails(''));
        dispatch(skipResponsibilityCheckForEMA(false));
        props.history.push("/startpage");
    };

    const clearCaseStoreData = () => {
        dispatch({ type: CLEAR_CASE_STATE });
        dispatch({ type: CASE_SELECTED_ANSWERS });
    };

    const openMobiledialer = () => {
        window.open('tel:' + t('phone_no'));
    };

    return (
        <>
            <HeaderJourney></HeaderJourney>
            <div className="gen_font gen_err">
                <div className="mt-24-gen-head">
                    <p className="mt-gen-err gen_font">
                        {t("alert_Message")}
                        {isMobile ?
                            (
                                <span className='underline'
                                    onClick={openMobiledialer}
                                    onKeyDown={openMobiledialer}>
                                    {t('phone_no')}
                                </span>
                            ) : (
                                <span>
                                    {t('phone_no')}
                                </span>
                            )}
                    </p>
                </div>
                <div className="container">
                    <Button
                        onClick={refreshButtonHandler}
                        className="primary-btn mt-gen-err button">
                        {t("Generic_Error_button")}
                    </Button>
                    <Button
                        onClick={RedirectToLogOut}
                        className="primary-btn mt-gen-err button">
                        {t("Header_Nav_Txt_Logout")}
                    </Button>
                </div>
            </div>
        </>
    )
}
export default CustomerApiErrorPage;